import { PropsWithChildren, ReactElement } from 'react';
import { Loader } from '../index';
import { LoadingDurationLogOptions, useLoadingDurationLog } from './useLoadingDurationLog';

interface SpinnerType extends LoadingDurationLogOptions {
  withBackDrop?: boolean;
  height?: string;
  position?: 'static' | 'absolute' | 'relative';
  reason: string;
}

const styles = {
  spinner: {
    position: 'absolute' as const,
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: 1000,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 'auto',
  },
};

const Spinner = ({
  withBackDrop,
  height,
  position,
  reason,
  withServiceWorkerDiagnostics,
}: SpinnerType): JSX.Element => {
  useLoadingDurationLog(reason, { withServiceWorkerDiagnostics });

  return (
    <div
      style={{
        position: 'relative',
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <div
        style={{
          ...styles.spinner,
          height: height || styles.spinner.height,
          position: position || styles.spinner.position,
          ...(withBackDrop && {
            backgroundColor: 'rgba(0,0,0,.54)',
          }),
        }}
      >
        <Loader />
      </div>
    </div>
  );
};

export function WithLoadingLog({
  children,
  reason,
  withServiceWorkerDiagnostics,
}: PropsWithChildren<{ reason: string } & LoadingDurationLogOptions>): ReactElement {
  useLoadingDurationLog(reason, { withServiceWorkerDiagnostics });

  return <>{children}</>;
}

export default Spinner;
